import { Wizard } from "lib/@components/wizard/wizard.js"
import { MappingSettingsLegislationContent } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/setting-components/mapping-settings-legislation-content.js"
import { MappingSettingsFacilityType } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/setting-components/mapping-settings-facility-type.js"
import { MappingConfidenceThreshold } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/setting-components/mapping-confidence-threshold.js"
import { MappingAssetTypeSetting } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/setting-components/mapping-asset-type-setting.js"
import { useMappingSettingsWizardSummaries } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/use-mapping-settings-wizard-summaries.js"
import { MappingScheduleTypePreference } from "routes/asset-register/plugins/asset-mapping/plugins/mapping-settings-wizard/setting-components/mapping-schedule-type-preference.js"

export function MappingSettingsWizard({ onFinish }) {
    const summaries = useMappingSettingsWizardSummaries()
    const steps = [
        {
            id: "asset-type",
            title: "Asset Type Settings",
            subtitle: "Choose one asset type mode (Required)",
            summary: summaries.assetTypeSummary,
            description:
                "Sets which asset types are used for mapping. Computed lets the AI refine and group the " +
                "uploaded types; unrefined uses them exactly as declared, skipping AI refinement.",
            content: <MappingAssetTypeSetting />,
        },
        {
            id: "confidence-threshold",
            title: "Accuracy",
            subtitle: "Set how confident the AI must be before it maps an asset type automatically (Required)",
            description:
                "Sets the confidence the AI requires to map a type automatically. Stricter yields fewer, " +
                "more reliable mappings; relaxed maps more but may leave more to review.",
            summary: summaries.confidenceThresholdSummary,
            content: <MappingConfidenceThreshold />,
        },
        {
            id: "schedule-type-preference",
            title: "Schedule Type Preference",
            subtitle: "Set the library the asset mapping will prioritize (Required)",
            description:
                "Sets which schedule library the AI maps against. “Only” options restrict mapping to " +
                "one library; “preferred” options use both but favour the chosen library on close matches.",
            summary: summaries.scheduleTypePreferenceSummary,
            content: <MappingScheduleTypePreference />,
        },
        {
            id: "legislation",
            title: "Legislation",
            subtitle: "Select one or more relevant legislation(s)",
            description:
                "Selects the regional legislation that applies to these assets. The AI only maps against " +
                "schedules relevant to the region you choose.",
            summary: summaries.legislationSummary,
            content: <MappingSettingsLegislationContent />,
        },
        {
            id: "facility-type",
            title: "Facility Type",
            subtitle: "Select facility types to prioritise",
            description:
                "Selects the facility types that apply to this site. Choosing a type makes its specialist " +
                "schedules eligible for mapping (e.g. Healthcare enables HTM schedules).",
            summary: summaries.facilityTypeSummary,
            content: <MappingSettingsFacilityType />,
        },
    ]

    return (
        <Wizard
            title="Mapping Settings"
            about="These settings let you configure how schedules are mapped to assets: by selecting the
                            relevant legislation, prioritising facility types (e.g. Healthcare), choosing not to use
                            AI-derived asset types if required, and setting the accuracy for automatic
                            mapping."
            icon="mdi:tune-vertical"
            steps={steps}
            showCancel={false}
            dataCy="mapping-settings"
            finishButtonText="Run Mobiliser"
            onFinish={onFinish}
        />
    )
}
